import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import BackgroundPattern from '../components/BackgroundPattern';
import Footer from '../components/Footer';
import blogPosts from '../data/blogPosts';

const BlogList = () => {
  return (
    <div className="min-h-screen text-white relative" style={{ backgroundColor: '#0a0a1a' }}>
      <BackgroundPattern />
      <Navbar />

      <main className="relative z-10 pt-24 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <header className="mb-16 text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-indigo-500/40 bg-indigo-500/10 px-4 py-1 text-xs sm:text-sm font-medium uppercase tracking-wider text-indigo-200">
              Insights & Updates
            </span>
            <h1 className="mt-6 text-3xl sm:text-4xl md:text-5xl font-bold text-white">
              From the VAISPtech Blog
            </h1>
            <p className="mt-4 text-base sm:text-lg text-gray-300 max-w-3xl mx-auto">
              Stay ahead with perspectives on engineering, design, automation, and the strategies powering tomorrow's digital products.
            </p>
          </header>

          <section className="grid gap-8 sm:grid-cols-2 xl:grid-cols-3">
            {blogPosts.map((post) => (
              <article
                key={post.slug}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-gray-800/70 bg-gray-900/70 shadow-lg shadow-indigo-900/20 transition-transform duration-300 hover:-translate-y-2 hover:border-indigo-500/70"
              >
                <div className={`h-48 w-full bg-gradient-to-br ${post.imageGradient}`} />
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center text-xs sm:text-sm text-gray-400">
                    <span>{post.date}</span>
                    <span className="mx-2 text-gray-600">•</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h2 className="mt-4 text-xl sm:text-2xl font-semibold text-white transition-colors duration-200 group-hover:text-indigo-300">
                    {post.title}
                  </h2>
                  <p className="mt-3 text-sm sm:text-base text-gray-300 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <div className="mt-6 flex items-center justify-between text-sm sm:text-base text-indigo-300">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center gap-2 rounded-full border border-indigo-500/40 bg-indigo-500/10 px-4 py-2 font-medium transition-all duration-200 hover:border-indigo-400 hover:bg-indigo-500/20"
                    >
                      Read More
                      <span aria-hidden="true">→</span>
                    </Link>
                    <span className="text-gray-400 text-xs sm:text-sm">{post.author}</span>
                  </div>
                </div>
              </article>
            ))}
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BlogList;
